function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { setVisible, createEl } from './util.js';
import { colors, files, ranks } from './types.js';
import { createElement as createSVG, setAttributes, createDefs } from './svg.js';
export function renderWrap(element, s) {
  // .cg-wrap (element passed to Chessground)
  //   cg-container
  //     cg-board
  //     svg.cg-shapes
  //       defs
  //       g
  //     svg.cg-custom-svgs
  //       g
  //     cg-auto-pieces
  //     coords.ranks
  //     coords.files
  //     piece.ghost
  element.innerHTML = '';
  // ensure the cg-wrap class is set
  // so bounds calculation can use the CSS width/height values
  // add that class yourself to the element before calling chessground
  // for a slight performance improvement! (avoids recomputing style)
  element.classList.add('cg-wrap');
  var _iterator = _createForOfIteratorHelper(colors),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var c = _step.value;
      element.classList.toggle('orientation-' + c, s.orientation === c);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  element.classList.toggle('manipulable', !s.viewOnly);
  var container = createEl('cg-container');
  element.appendChild(container);
  var board = createEl('cg-board');
  container.appendChild(board);
  var svg;
  var customSvg;
  var autoPieces;
  if (s.drawable.visible) {
    svg = setAttributes(createSVG('svg'), {
      class: 'cg-shapes',
      viewBox: '-4 -4 8 8',
      preserveAspectRatio: 'xMidYMid slice'
    });
    svg.appendChild(createDefs());
    svg.appendChild(createSVG('g'));
    customSvg = setAttributes(createSVG('svg'), {
      class: 'cg-custom-svgs',
      viewBox: '-3.5 -3.5 8 8',
      preserveAspectRatio: 'xMidYMid slice'
    });
    customSvg.appendChild(createSVG('g'));
    autoPieces = createEl('cg-auto-pieces');
    container.appendChild(svg);
    container.appendChild(customSvg);
    container.appendChild(autoPieces);
  }
  if (s.coordinates) {
    var orientClass = s.orientation === 'black' ? ' black' : '';
    var ranksPositionClass = s.ranksPosition === 'left' ? ' left' : '';
    if (s.coordinatesOnSquares) {
      var rankN = s.orientation === 'white' ? function (i) {
        return i + 1;
      } : function (i) {
        return 8 - i;
      };
      files.forEach(function (f, i) {
        return container.appendChild(renderCoords(ranks.map(function (r) {
          return f + r;
        }), 'squares rank' + rankN(i) + orientClass + ranksPositionClass));
      });
    } else {
      container.appendChild(renderCoords(ranks, 'ranks' + orientClass + ranksPositionClass));
      container.appendChild(renderCoords(files, 'files' + orientClass));
    }
  }
  var ghost;
  if (s.draggable.enabled && s.draggable.showGhost) {
    ghost = createEl('piece', 'ghost');
    setVisible(ghost, false);
    container.appendChild(ghost);
  }
  return {
    board: board,
    container: container,
    wrap: element,
    ghost: ghost,
    svg: svg,
    customSvg: customSvg,
    autoPieces: autoPieces
  };
}
function renderCoords(elems, className) {
  var el = createEl('coords', className);
  var f;
  var _iterator2 = _createForOfIteratorHelper(elems),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var elem = _step2.value;
      f = createEl('coord');
      f.textContent = elem;
      el.appendChild(f);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return el;
}